/**
 * Affiliate referral attribution: captures ?ref= from a landing URL into
 * localStorage so it can be attached to registration and DNA kit purchases
 * that happen later in the same browser session.
 */

const REFERRER_STORAGE_KEY = 'lw_referrer'

export function captureReferrerFromParams(searchParams: URLSearchParams): void {
  const refParam = searchParams.get('ref')
  if (refParam) {
    localStorage.setItem(REFERRER_STORAGE_KEY, refParam)
  }
}

export function getStoredReferrer(): string | undefined {
  return localStorage.getItem(REFERRER_STORAGE_KEY) || undefined
}

export function clearStoredReferrer(): void {
  localStorage.removeItem(REFERRER_STORAGE_KEY)
}
